// Copyright (c) Docugami, Inc. All rights reserved.

import { CanvasHelperStatics } from "components/doc_hosting/doc_hosts/web/CanvasHelperStatics";
import { ComponentId } from "sdv/engine/Component";
import { IDrawCommand, IRenderer, IRendererInput, Queries } from "sdv/engine/Engine";
import { chunkGrabHandleBorderColor, chunkGrabHandleFillColor } from "components/shell/presentation/AppStyles";
import { Grabber, GrabberComponent } from "sdv/components/GrabberComponent";

/**
 * Renders grab handles for chunks
 */
export class GrabHandleRenderer implements IRenderer {
    get renderEnabled(): boolean { return true; }

    queries: Queries = {
        grabbers: { types: [ComponentId.Grabber, ComponentId.Renderable] }
    }

    render(engine: IRendererInput): IDrawCommand[] {
        const commands: IDrawCommand[] = []

        for (const entity of this.queries.grabbers.query!.entities) {
            const grabberComponent = entity.getComponent<GrabberComponent>(ComponentId.Grabber)!;
            commands.push(context => drawHandle(context, grabberComponent.grabber))
        }

        return commands;
    }
}

function drawHandle(context: CanvasRenderingContext2D, grabber: Grabber): void {
    CanvasHelperStatics.strokeRectangle(
        context,
        grabber.visual,
        chunkGrabHandleBorderColor,
        2,
        false,
        chunkGrabHandleFillColor);
}
